/**
 * Screen Interactive Hook
 *
 * 네이티브 onScreenStateChange 이벤트 중 interactive 상태만 감지하는 React Hook
 */

import { useNativeEvent } from './useNativeEvent'

type ScreenInteractiveHandler = () => unknown

export function useOnScreenInteractive(onInteractive: ScreenInteractiveHandler): void {
  useNativeEvent('lifecycle', 'onScreenStateChange', async data => {
    if (data.state !== 'interactive') {
      return
    }

    await onInteractive()
  })
}
